import {IABTestingState} from "../interfaces/IABTestingState";

export const abTestingSelector = (abTestId: string) => (state: IABTestingState) => state.abTesting.tests[abTestId];
import {IABTestingState} from "../interfaces/IABTestingState";

export const abTestingSelector = (abTestId: string) => (state: IABTestingState) => state.abTesting.tests[abTestId];
